export interface FocusManager {
  isFocused: () => boolean;
  subscribe: (listener?: () => unknown) => () => void;
}
